var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      ref: "svg",
      staticClass: "EditorCanvas",
      attrs: {
        width: _vm.zoomedWidth,
        height: _vm.zoomedHeight,
        viewBox: _vm.viewbox
      },
      on: { click: _vm.onClickSVG }
    },
    [
      _c(
        "image",
        _vm._b(
          {
            staticClass: "EditorCanvas_Image",
            attrs: {
              width: _vm.editScreen.width,
              height: _vm.editScreen.height
            },
            on: { load: _vm.onLoadImage, error: _vm.onErrorImage }
          },
          "image",
          { "xlink:href": _vm.imageSrc },
          false
        )
      ),
      _vm._v(" "),
      _vm._l(_vm.coordinates, function(coordinate, index) {
        return _c("Highlight", {
          key: index,
          attrs: {
            order: index,
            coordinate: coordinate,
            selected: index === coordinate.selectedItem,
            width: _vm.editScreen.width,
            height: _vm.editScreen.height,
            getCoordinateByXY: _vm.getCoordinateByXY
          },
          on: {
            selectHighlight: _vm.onSelectHighlight,
            setCoordinates: _vm.onSetCoordinates
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }